import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEmpresasContext } from "../empresas-context";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TextField,
  Box,
  Chip,
  Container,
} from "@mui/material";
import { Spinner } from "reactstrap";
import { MdAppRegistration, MdArticle, MdRefresh } from "react-icons/md";

const initialState = "";

export function EmpresasTable() {
  const navigate = useNavigate();

  const {
    data,
    isLoading,
    queryParams,
    setQueryParams,
    refetch,
    isRefetching,
  } = useEmpresasContext();

  const [search, setSearch] = useState(queryParams.query || initialState);

  useEffect(() => {
    (async () => await refetch())();
  }, [refetch]);

  function handleSubmit(e) {
    e.preventDefault();

    const value = search.trim();

    setQueryParams(!!value ? { query: value } : {});
  }

  function handleReset() {
    setSearch(initialState);

    setQueryParams({});
  }

  function handleChangePage(_e, newPage) {
    setQueryParams((queryParams) => ({
      ...queryParams,
      page: newPage + 1,
    }));
  }

  function handleChangeRowsPerPage(e) {
    setQueryParams((queryParams) => ({
      ...queryParams,
      page: 1,
      limit: +e.target.value,
    }));
  }

  return (
    <Container
      className="animate__animated animate__fadeIn"
      maxWidth="xl"
      sx={{ padding: 2 }}
    >
      <Paper sx={{ padding: 1 }} variant="outlined">
        <Stack>
          <Stack justifyContent="space-between" direction="row" padding={2}>
            <Stack direction="row" alignItems="center" justifyContent="center">
              <Typography variant="h6">
                <strong>Empresas</strong>
              </Typography>

              <Tooltip title="Refrescar">
                <IconButton onClick={refetch}>
                  <MdRefresh />
                </IconButton>
              </Tooltip>
            </Stack>

            <Stack
              component="form"
              onSubmit={handleSubmit}
              onReset={handleReset}
              direction="row"
              spacing={1}
              justifyContent="space-between"
              alignItems="center"
            >
              <TextField
                label="Buscar"
                size="small"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                fullWidth
              />
            </Stack>
          </Stack>

          {!!isLoading || !!isRefetching ? (
            <Stack justifyContent="center" alignItems="center" padding={2}>
              <Spinner color="secondary" />
            </Stack>
          ) : !!data.results.length ? (
            <Box>
              <TableContainer>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      {[
                        "Código",
                        "Empresa",
                        "RTN",
                        "Fecha de inscripción",
                        "Opciones",
                      ].map((column, index) => (
                        <TableCell key={index}>
                          <Typography variant="overline">
                            <strong>{column}</strong>
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.results.map((result) => (
                      <TableRow key={result.empresa_id} hover>
                        <TableCell>
                          <strong>{result.empresa_id}</strong>
                        </TableCell>

                        <TableCell>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography>
                              <strong>{result.empresa_nombre_comercial}</strong>
                            </Typography>

                            {!!result.empresa_afiliada && (
                              <Chip
                                label="Afiliada"
                                size="small"
                                color="success"
                                variant="outlined"
                              />
                            )}
                          </Stack>

                          <Typography variant="body2">
                            {result.denominacion_social_nombre}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography variant="body2">
                            {result.empresa_rtn || "-"}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography variant="body2">
                            {result.registro_ccia_fecha}
                          </Typography>
                        </TableCell>

                        <TableCell align="center">
                          <Stack direction="row" justifyContent="center">
                            <Tooltip title="Detalles">
                              <IconButton
                                color="info"
                                onClick={() =>
                                  navigate(`../${result.empresa_id}`)
                                }
                              >
                                <MdArticle />
                              </IconButton>
                            </Tooltip>

                            {/* <Tooltip title="Reinscripciones">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `../${result.empresa_id}/reinscripciones`
                                  )
                                }
                              >
                                <MdAppRegistration />
                              </IconButton>
                            </Tooltip> */}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={data.count || 0}
                page={data.page - 1 || 0}
                onPageChange={handleChangePage}
                rowsPerPage={data.limit || 10}
                onRowsPerPageChange={handleChangeRowsPerPage}
                showFirstButton
                showLastButton
              />
            </Box>
          ) : (
            <Typography
              align="center"
              variant="overline"
              className="animate__animated animate__shakeX"
            >
              Sin resultados
            </Typography>
          )}
        </Stack>
      </Paper>
    </Container>
  );
}
